import type { FlagKey, FlagState } from '$models/FeatureFlags/FeatureFlags';
import { updateFeatureFlagsFromUrl } from '$lib/featureFlags/client';
import { getContext, setContext } from 'svelte';

const key = Symbol('featureFlagsState');

export function createFeatureFlagsState(initialFlags: FlagState = {}) {
	let flags = $state(initialFlags);

	return {
		getFlag(flagKey: FlagKey): boolean {
			return flags[flagKey] ?? false;
		},
		setFlag(flagKey: FlagKey, value: boolean): void {
			flags[flagKey] = value;
		},
		isEnabled(flagKey: FlagKey): boolean {
			return flags[flagKey] === true;
		},
		getAllFlags(): FlagState {
			return flags as FlagState;
		},
		updateFlags(newFlags: Partial<FlagState>): void {
			flags = { ...flags, ...newFlags };
		}
	};
}

export function setFeatureFlagsState(
	featureFlagsState: ReturnType<typeof createFeatureFlagsState>
) {
	setContext(key, featureFlagsState);
}

export function getFeatureFlagsState(): ReturnType<typeof createFeatureFlagsState> {
	return getContext(key);
}

export const flags = createFeatureFlagsState();

export function isFlagEnabled(flagKey: FlagKey): boolean {
	return flags.isEnabled(flagKey);
}
